import React, { useCallback, useEffect, useState } from 'react'
import { Loader } from '@refera/ui-web'

import { useDispatch } from 'react-redux'
import { useToast } from '_/hooks/use-toast'
import { useParams } from '@reach/router'
import { getAgencyAdditionalConfig } from '_/modules/agency/actions'
import AdditionalConfigForm from './form'
import useStyles from './styles'
import { Grid } from '@mui/material'

export default function AdditionalConfig() {
  const styles = useStyles()
  const { agencyId } = useParams()
  const dispatch = useDispatch()
  const { showToast } = useToast()
  const [loading, setLoading] = useState(true)

  const getDataForm = useCallback(() => {
    if (agencyId) {
      setLoading(true)

      return dispatch(getAgencyAdditionalConfig(agencyId))
        .catch(() => {
          showToast({ type: 'error', message: 'Ocorreu um erro ao buscar os dados.' })
        })
        .finally(() => {
          setLoading(false)
        })
    }
    return null
  }, [dispatch, agencyId])

  useEffect(() => {
    getDataForm()
  }, [agencyId])

  if (loading) {
    return (
      <Grid className={styles.loader}>
        <Loader />
      </Grid>
    )
  }

  return <AdditionalConfigForm getDataForm={getDataForm} />
}
